export default __webpack_public_path__ + "static/media/kinder10.6d8a66ba.jpg";